import React, { useState, useEffect } from "react";
import ElementWrapper from "../ElementWrapper";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import FilterWrapper from "../filter/FilterWrapper";
import shortid from "shortid";
import { useSelector } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import FilterableList from "../../administration/components/FilterableList.js";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { Trans, useTranslation } from "react-i18next";
import axios from "../../AxiosClient";

import {
  Responsive as ResponsiveGridLayout,
  WidthProvider,
} from "react-grid-layout";

const useStyles = makeStyles((theme) => ({
    taxonomyDialog: {
        minWidth: 300,
        minHeight: 300,
        overflow: "auto",
    },
  }));
//   const theme = useTheme()
//   const disabledColourTheme = `${theme.palette.text.disabled}`
//   const topicColourTheme = `${theme.palette.primary.dark}`

function TopicHomePage(props) {
    const topicSVG =
  "M12,3C7.58,3 4,4.79 4,7C4,9.21 7.58,11 12,11C16.42,11 20,9.21 20,7C20,4.79 16.42,3 12,3M4,9V12C4,14.21 7.58,16 12,16C16.42,16 20,14.21 20,12V9C20,11.21 16.42,13 12,13C7.58,13 4,11.21 4,9M4,14V17C4,19.21 7.58,21 12,21C16.42,21 20,19.21 20,17V14C20,16.21 16.42,18 12,18C7.58,18 4,16.21 4,14Z";

    const WidthAwareGridLayout = WidthProvider(ResponsiveGridLayout)
    const gridNumColumns = { lg: 6, md: 3, sm: 2, xs: 1, xxs: 1 }
    const [filterSettings, setFilterSettings] = useState(          
        {
            filters: {},
            showFilters: false,
            filterTitle: "",
            showReset: false,
            resetToDefaultFilters: false,
        })
    const [resizingPortlet,setResizingPortlet] = useState(-1)
    const [breakpoint, setBreakpoint] = useState("lg")
    const [layout, setLayout] = 
    useState(
        {
            "lg":[
                {"w":2,"h":1,"x":0,"y":0,"i":"1129","moved":false,"static":false},
                {"w":2,"h":1,"x":1,"y":0,"i":"1020","moved":false,"static":false},
                {"w":4,"h":2,"x":1,"y":0,"i":"1046","moved":false,"static":false}
            ],
            "xs":[
                {"w":1,"h":1,"x":0,"y":0,"i":"1129","moved":false,"static":false},
                {"w":1,"h":1,"x":0,"y":1,"i":"1020","moved":false,"static":false},
                {"w":1,"h":1,"x":0,"y":1,"i":"1046","moved":false,"static":false}
            ],
            "xxs":[],
            "sm":[
                {"w":2,"h":1,"x":0,"y":0,"i":"1129","minW":2,"moved":false,"static":false},
                {"w":2,"h":1,"x":0,"y":1,"i":"1020","minW":2,"moved":false,"static":false},
                {"w":2,"h":1,"x":0,"y":1,"i":"1046","minW":2,"moved":false,"static":false}
            ],
            "md":[
                {"w":2,"h":1,"x":0,"y":0,"i":"1129","moved":false,"static":false},
                {"w":2,"h":1,"x":0,"y":0,"i":"1020","moved":false,"static":false},
                {"w":2,"h":1,"x":0,"y":0,"i":"1046","moved":false,"static":false}
            ]
        }
    )
    const [fullscreenPortletId, setFullscreenPortletId] = useState(null)
    const [hasFullscreen, setHasFullscreen] = useState(false)
    const [wasFullscreen, setWasFullscreen] = useState(false)
    const [layoutBeforeFullscreen, setLayoutBeforeFullscreen] = useState(null)
    const taxonomyNodeLookup = useSelector((state) => (
        [...state.taxonomy.taxonomyNodeLookup]
    ));
    const [taxonomyFilter,setTaxonomyFilter] = useState([])
    const [topicName, setTopicName] = useState("")
    const [showTopicDialog, setShowTopicDialog] = useState(false)
    const [topicId, setTopicId] = useState(props.topicId)
    const classes = useStyles();
    const { t } = useTranslation();
    const [portlets,setPortlets] = useState([])

    useEffect(() => {
        if (props.showTopicDialog) {
            setShowTopicDialog(props.showTopicDialog) 
        }
    },[props.showTopicDialog])
    useEffect(() => {
        if (!topicId || topicId === "") {
            setShowTopicDialog(true) 
            return
        } else {
            let topics = taxonomyNodeLookup.filter(t => t.id === topicId && t.type === "topic")
            if (topics.length > 0) {
                //found it in the user searchable taxonomy. Remember ones that are unattached will not be found
                let result = topics.map(t => {
                    return {id: t.id, type: t.type, parentList: t.parentList, taxArray:[]}
                })
                const topicName = topics.length > -1 ? topics[0].name : ""
                setTopicName(topicName)
                setTaxonomyFilter(result)
                let updated = portlets.map(p => { 
                    p.parameters = JSON.stringify({...JSON.parse(p.parameters), taxonomy: result})
                    p.originalMenuPortlet = {...p.originalMenuPortlet, parameters: p.parameters}
                    p.title = p.originalMenuPortlet.title + ` for ${topicName}`
                    return p
                })
                setPortlets(updated)
            }
        }
    },
    [topicId])

    useEffect(
        () => {
            let portletids = layout[breakpoint].map(lp => parseInt(lp.i))
            taxonomyFilter.length > 0 && portletids.length > 0 &&
                axios
                    .get("/menuportlet/forlist/" + portletids, { withCredentials: true })
                    .then((res) => {
                        let myportlets = res.data.map(p => {
                            let params = JSON.stringify({...JSON.parse(p.parameters), taxonomy: taxonomyFilter})
                            let title = p.title.startsWith("$t(") ? p.title : "$t(" + p.title + ")"
                            return {
                                ...p, 
                                title: title + ` for ${topicName}`,
                                instance: shortid.generate(),
                                parameters: params,
                                originalMenuPortlet: {
                                    ...p,
                                    parameters: params,
                                },
                                fullscreen: false,
                            }
                        })
                        setPortlets(myportlets)
                    })
        },
        [taxonomyFilter]
    )

    let droppables = {}

    const toggleFilters = (
        anchorEl,
        filterElement,
        filters,
        onFilterChange,
        filterTitle,
        showReset,
        resetToDefaultFilters,
        instance,
        objectClass,
      ) => {
        var filter = filterSettings.showFilters;
        anchorEl === filterSettings.filterAnchorEl && filterSettings.showFilters === true
          ? (filter = false)
          : (filter = true);
    
        setFilterSettings(
          {
            filters: filters,
            showFilters: filter,
            filterAnchorEl: anchorEl,
            filterElement: filterElement,
            filterTitle: filterTitle,
            showReset: showReset,
            resetToDefaultFilters: resetToDefaultFilters,
            filterInstance: instance,
            objectClass: objectClass,
            onFilterChange: onFilterChange,
          }
        );
      };
      const onFilterChange = (newFilter) => {
        let pos = portlets.map(p => p.instance).indexOf(filterSettings.filterInstance)
        if (pos > -1) {
            const canReset = !areEqual(newFilter,portlets[pos].originalMenuPortlet.parameters)
            let updated = {...portlets[pos], parameters: JSON.stringify(newFilter)}
            portlets.splice(pos,1,updated)
            setPortlets(portlets)
            setFilterSettings({...filterSettings,filters: newFilter, showReset: canReset})
        }
        filterSettings.onFilterChange &&
            filterSettings.onFilterChange(newFilter)
      }
      const resetToDefaultFilters = () => {
        let pos = portlets.map(p => p.instance).indexOf(filterSettings.filterInstance)
        let params = portlets[pos].originalMenuPortlet.parameters
        if (pos > -1) {
            let updated = {...portlets[pos], parameters: typeof params === "object" ? JSON.stringify(params) : params}
            portlets.splice(pos,1,updated)
            setPortlets(portlets)
            setFilterSettings({...filterSettings,filters: typeof params === "object" ? JSON.stringify(params) : params, showReset: false})
        }
      }
      const handleDialogClose = () => {
        setShowTopicDialog(false)
        props.closeTopicDialog && 
            props.closeTopicDialog()
      }
      const topicSelected = (newTopic) => {
        setTopicId(newTopic.id)
        setTopicName(newTopic.name)
        props.updateTopic && props.updateTopic(newTopic)
      }


      const setFullscreen = (fullscreen, portlet) => {
        // document.querySelector(".swipeable-slide").scrollTop = 0;
        setHasFullscreen(fullscreen);
        if (fullscreen) {
          //if fullscreen already exists
          if (layoutBeforeFullscreen && fullscreenPortletId) {
            let newLayout = JSON.parse(
              JSON.stringify(layoutBeforeFullscreen)
            );
            //revert the layout to what it was before anything was fullscreen
            setLayout(layoutBeforeFullscreen)
            //and after that has happened fullscreen the new portlet
            makePortletFullscreen(portlet);
          } else {
            // if a fulllscreen does not already exist save the current layout as layoutBeforeFullscreen
            setLayoutBeforeFullscreen(layout)
            makePortletFullscreen(portlet)
          }
        } else {
          //if stopping a fulscreen reuse previous layout and null the fullscreenportletid
          setWasFullscreen(true)
          setFullscreenPortletId(null)
          setLayout(layoutBeforeFullscreen)
        }
        this.props.onFullscreen && 
            this.props.onFullscreen(fullscreen, this.props.layoutId);
      };
      const makePortletFullscreen = (portlet) => {
        let newLayout = JSON.parse(JSON.stringify(layout));
        //then make the correct portlet fullscreen
        newLayout[breakpoint] = newLayout[
            breakpoint
        ].map((ele) => {
          if (ele.i == portlet.id) {
            return {
              ...ele,
              w: gridNumColumns[breakpoint],
              h: 2,
              x: 0,
              y: 0,
            };
          } else {
            return { ...ele, y: ele.y + 2 }
          }
        });
        //save the new layout and portletid
       setLayout(newLayout) 
       setFullscreenPortletId(portlet.id)
      }

      const updateFilters = (newfilters, showReset, instance) => {
        if (
            filterSettings.filterInstance === instance ||
            filterSettings.filterInstance === ""
        ) {
          setFilterSettings(
            {
              filters: newfilters,
              showReset: showReset,
            }
          );
        }
      };
      const updatePortlet = (item) => {
        let definition = portlets.filter(p => p.id === item.id)
        let a = definition
        // this.setState({ item });
      };
    
      const onLayoutChange = (e, currentLayout) => {

        // if (hasFullscreen) return;
        if (areEqual(currentLayout, layout)) return;
      
        setLayout(currentLayout);

        // if (this.state.wasFullscreen) {
        //   this.setState({ wasFullscreen: false });
        // }
      };
      const areEqual = (object1, object2) => {
        var equal = require("deep-equal");
        return equal(object1, object2) ? true : false;
      };
      const onDragEnd = (result) => {
        // const { source, destination } = result;
        // if (!destination) return;
        // let layouts = [...this.state.layouts];
        // if (source.droppableId === destination.droppableId) {
        //   droppables[destination.droppableId].reorderList(
        //     source.index,
        //     destination.index
        //   );
        // } else {
        //   let removed = droppables[source.droppableId].removeFromList(source.index);
        //   droppables[destination.droppableId].addToList(destination.index, removed);
        // }
    
        // if (result.type === "top") {
        //   const [removed] = layouts.splice(result.source.index, 1);
        //   layouts.splice(result.destination.index, 0, removed);
        //   layouts.forEach((ele, idx) => (ele.orderNumber = idx));
        //   this.setState({ layouts });
        // }
      };
    
    const onClose = () => {
        setFilterSettings({...filterSettings,showFilters: false})
    }

    const getTopicSecondaryInfo = () => {
        return (<></>)
    }

    const getTopicPrimaryInfo = (item) => {
        return (<>{item.name}</>)
    }
    const sortData = (a,b) => {
        return a > b ? 1 : a < b ? -1 : 0
    }
    const dataProvider = (pageNo,pageSize,filter,sort,sortDirection) => {
        //we have the list of Topics on the user selectable
        let res = {data:{}}
        let topics = taxonomyNodeLookup
            .filter(t => filter && filter.length > 0 ? (t.name.toLowerCase().includes(filter.toLowerCase()) && t.type === "topic") : t.type === "topic")
            .map(t => {return {id: t.id, name: t.name}})
        //remove duplicates by turning each object into a string and creating a set before re-parsing as objects
        topics = [...new Set(topics.map(t => JSON.stringify(t)))].map(t => JSON.parse(t))
            .sort((a,b) => {
                let sortColumn = sort && sort.length > 0 ? sort : "name"
                let sortOrder = sortDirection && sortDirection.length > 0 ? sortDirection : "ASC"  
                let sorter =
                    sortOrder.toUpperCase() === "ASC" 
                        ? sortData(a[sortColumn].toLowerCase().trim(),b[sortColumn].toLowerCase().trim()) 
                        : sortData(b[sortColumn].toLowerCase().trim(),a[sortColumn].toLowerCase().trim()) 
                return sorter
            
        })
        
        res.data.content = topics.slice(pageNo * pageSize, pageNo * pageSize + pageSize)
        res.data.totalPages = Math.ceil(topics.length / pageSize)
        return res
    }
    return ( 
        <>
            <DragDropContext onDragEnd={onDragEnd}>
                {topicId && portlets.length > 0 ?
                <WidthAwareGridLayout
                    compactType={"horizontal"}
                    cols={gridNumColumns}
                    breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
                    rowHeight={400}
                    isDraggable={true}
                    isResizable={true}
                    style={{ width: "100%" }}
                    layouts={layout}
                    draggableHandle=".handle"
                    onLayoutChange={onLayoutChange}
                    onBreakpointChange={setBreakpoint}
                    onResizeStart={(layout, oldItem, newItem, placeholder, e, element) => {
                        setResizingPortlet(parseInt(newItem.i))
                    }}
                    onResizeStop={(layout, oldItem, newItem, placeholder, e, element) => {
                        setResizingPortlet(-1)
                    }}
                >
                    {portlets.map((portlet) => {
                    let layout = {};
                    if (layout[breakpoint]) {
                        layout = layout[
                        breakpoint
                        ].filter((ele) => ele.i == portlet.id)[0];
                    }
                    if (!layout || !layout.h) {
                        layout = { h: portlet.fullscreen === true ? 2 : 1, w: 2, minW: 2, x: 0, y: 0 };
                    } else if (layout.h === 1 && portlet.fullscreen) {
                        // if the layout has this portlet with a height of 1 and its fullscreen then the change to the 
                        // number of rows caused by this makes the CardList call the backend multiple times leading to cancelled xhr requests
                        // layout.h = 2
                    }
                    return (
                        <div key={portlet.id}>
                        <ElementWrapper
                            key={portlet.instance}
                            portlet={portlet}
                            toggleFilters={toggleFilters}
                            updateFilters={updateFilters}
                            updatePortlet={updatePortlet}
                            menuDialog={false}
                            filters={portlet.parameters}
                            resizing={resizingPortlet === portlet.id}
                            setFullscreen={setFullscreen}
                            fullscreen={
                                !props.isMobile &&
                                fullscreenPortletId === portlet.id &&
                                breakpoint != "xs"
                            }
                            cansort={true}
                            height={layout.h === 1 && portlet.fullscreen ? 2 * 400 : layout.h * 400}
                            rows={layout.h === 1 && portlet.fullscreen ? 2 : layout.h}
                            width={layout.w}
                            {...props}
                            noTaxonomy
                        />
                        </div>
                    )
                    })}
                </WidthAwareGridLayout>
                :<></>
                }
            </DragDropContext>
            {hasFullscreen !== true && (
                <FilterWrapper
                    asPopper={true}
                    open={filterSettings.showFilters}
                    onClose={onClose}
                    anchorEl={filterSettings.filterAnchorEl}
                    filterElement={filterSettings.filterElement}
                    filter={filterSettings.filters}
                    onFilterChange={onFilterChange}
                    isFilterBar={false}
                    title={filterSettings.filterTitle}
                    showReset={filterSettings.showReset}
                    resetToDefaultFilters={resetToDefaultFilters}
                    filterInstance={filterSettings.filterInstance}
                    objectClass={filterSettings.objectClass}
                    isMobile={props.isMobile}
                    noTaxonomy
                />
            )}
            <Dialog
                open={showTopicDialog}
            >
                <DialogTitle>
                    <Trans
                        i18nKey={"taxonomy_tree_topic_header"}
                    />
                </DialogTitle>
                <DialogContent className={classes.taxonomyDialog}>
                    <FilterableList
                        dataurl="/topic"
                        // filterElement={"FilterTopics"}
                        name="name"
                        getPrimaryInfo={getTopicPrimaryInfo}
                        getSecondaryInfo={getTopicSecondaryInfo}
                        // isItemEnabled={this.isTopicItemEnabled}
                        // iconColour={this.state.topicColourTheme}
                        // iconColourDisabled={this.state.disabledColourTheme}
                        iconSVG={topicSVG}
                        onItemSelected={topicSelected}
                        dataProvider={dataProvider}
                        // organization={this.state.organization}
                        // dragStart={this.dragStart}
                        // dragEnd={this.dragEnd}
                        // addItem={this.openAddTopicDialog}
                        // editItem={this.editTopic}
                        // needsUpdate={this.state.topicNeedsUpdate}
                        // onUpdate={() => {
                        //     this.setState({ topicNeedsUpdate: false });
                        // }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        disabled={!topicId}
                        onClick={() => { 
                            handleDialogClose()
                        }}
                        color="primary"
                    >
                        <Trans
                            i18nKey={"global_done"}
                        />
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default TopicHomePage
